import styled from 'styled-components'

export const StAwellHtml = styled.div`
  p {
    ${({ theme }) => theme.Typography.BodyLargeRegular}
    color: ${({ theme }) => theme.Colors.Neutrals.Darker};
    margin-bottom: ${({ theme }) => theme.UI.SpacingPx.Space4};
  }
`
